// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iGk9","toggle":"styles_toggle__2VyGl","preview":"styles_preview__14uiw"};